import { AxiosInstance } from "axios"

export interface AgentCommission {
  bookingId: string
  bookingNumber: string
  commissionRate: number
  commissionAmount: number
  commissionStatus: "PENDING" | "ELIGIBLE" | "PAID"
  eligibleDate: number[] | null
  paidDate: string | null
  createdDt: number[]
  agentName?: string
  transferError?: string | null
  transferErrorAt?: number[] | null
}

export interface GetAgentCommissionsRequest {
  status?: string
  page: number
  size: number
  filterAgentId?: number
  csv?: boolean
}

export interface GetAgentCommissionsResponse {
  apiStatus: string
  data: {
    content: AgentCommission[]
    totalElements: number
    totalPages: number
    number: number
    size: number
    first: boolean
    last: boolean
    empty: boolean
  }
}

export function getAgentCommissionsApi(
  params: GetAgentCommissionsRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: "/agent/commissions",
    params,
    responseType: params.csv ? "blob" : "json",
  }) as Promise<{ data: GetAgentCommissionsResponse }>
}
